// Colors.tsx
const Colors = {
    background: '#F8F8F8',

    black: '#000000',
    grey9: '#1a1a1a',
    grey8: '#333333',
    grey7: '#4d4d4d',
    grey6: '#666666',
    grey5: '#808080',
    grey4: '#999999',
    grey3: '#b3b3b3',
    grey2: '#cccccc',
    grey1: '#e6e6e6',
    white: '#ffffff',
    whiteTransparent: 'rgba(255, 255, 255, 0.2)',
    blackTransparent: 'rgba(0, 0, 0, 0.2)',
    transparent: 'rgba(0, 0, 0, 0)',

    blue: '#006997',
    blueDark: '#004360',
    blueLight: '#4084A2',
    blueTransparent: 'rgba(23, 154, 202, 0.1)',
    grayVeryPale: '#F8F8F8',
    grayPale: '#F2F2F2',
    grayLight: '#CECECE',
    grayMed: '#424956',
    grayDark: '#1E1E1E',
    pale: '#EAF5F9',
    paleBright: '#D7EBF2',

    red: '#D3372A',
    green: '#008E17',
    yellow: '#D7A700',

    // Dark mode specific shades for backgrounds
    redDark: '#6A1A14', // Made darker
    greenDark: '#004A0B', // Made darker
    yellowDark: '#6C5300', // Made darker

    // Light mode specific shades for accents (can be same as base if suitable)
    redLight: '#E84134',
    greenLight: '#00C323',
    yellowLight: '#FFC800',

    redPale: '#FBEFEB',
    greenPale: '#E5F5E7',
    yellowPale: '#FFFDDB',

    vizDefault: 'lightcoral',
    expressionDefault: '#676767',

    websiteYellow: '#FFDA48',
    websiteRed: '#FF452D',
    websiteBlue: '#0004FF',
    websitePink: '#FFDDE8',
    websiteCyan: '#E0F9FF',

    colorRed: '#EF4444',
    colorOrange: '#F97316',
    colorAmber: '#F59E0B',
    colorYellow: '#EAB308',
    colorLime: '#84CC16',
    colorGreen: '#22C55E',
    colorEmerald: '#10B981',
    colorTeal: '#14B8A6',
    colorCyan: '#06B6D4',
    colorSky: '#0EA5E9',
    colorBlue: '#3B82F6',
    colorIndigo: '#6366F1',
    colorViolet: '#8B5CF6',
    colorPurple: '#A855F7',
    colorFuchsia: '#D946EF',
    colorPink: '#EC4899',
    colorRose: '#F43F5E',
}

export const blendWithWhite = (hex, opacity) => `#${hex.replace(/^#/, '').match(/.{2}/g).map(c => Math.round((parseInt(c, 16) * opacity) + (255 * (1 - opacity))).toString(16).padStart(2, '0')).join('')}`;

export const blendWithBlack = (hex, opacity) => {
    // Convert hex to RGB
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // Blend with black
    const blendedR = Math.round(r * (1 - opacity));
    const blendedG = Math.round(g * (1 - opacity));
    const blendedB = Math.round(b * (1 - opacity));

    // Convert back to hex
    return `#${blendedR.toString(16).padStart(2, '0')}${blendedG.toString(16).padStart(2, '0')}${blendedB.toString(16).padStart(2, '0')}`;
};

export const isLightColor = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // Calculate perceived brightness using the formula: (0.299*R + 0.587*G + 0.114*B)
    const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return brightness > 0.5; // If brightness is greater than 0.5, consider it a light color
};

export default Colors;